import { cnMerge, type CnOptions } from "tailwind-variants";

/**
 * Usage example
 *
 * ```
 *	import { cn } from '@ui/utils'
 *
 *	const Example = () => {
 * 	const condition1 = true
 *		return (
 *			<div className={cn("px2 py-3", condition1 ? "bg-blue-500" "bg-red-500")}>
 *			    My div
 *			</div>
 *		)
 *	}
 *
 * ```
 * @param classes
 */
export const cn = <T extends CnOptions>(...classes: T) => cnMerge(...classes)({ twMerge: true });
